import PopoverListWithFilter from '@shared/components/others/PopoverListWithFilter/PopoverListWithFilter';
import { Link, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { UI_FUNCTIONAL_TESTING_PATH, UI_TEST_PLAN_PATH } from '@shared/constants/pathsConstants';
import { toTitleCase } from '@shared/utils/utilsOld';

const TestPlansPopover = ({ open, setOpen, testPlans }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <PopoverListWithFilter
            anchorEl={open}
            setAnchorEl={setOpen}
            data={testPlans}
            dataFilterFields={['pk', 'title']}
            renderValue={(testplan) => (
                <TableRow key={testplan.pk}>
                    <TableCell size="small">{testplan.pk}</TableCell>
                    <TableCell size="small" sx={{ wordBreak: 'break-all' }}>
                        <Link
                            underline="hover"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_PLAN_PATH}/${testplan.pk}`);
                                setOpen(null);
                            }}
                            sx={{ cursor: 'pointer' }}
                            href={`/${UI_FUNCTIONAL_TESTING_PATH}/${UI_TEST_PLAN_PATH}/${testplan.pk}`}
                        >
                            {testplan.title}
                        </Link>
                    </TableCell>
                </TableRow>
            )}
            table={{ columns: ['ID', toTitleCase(t('test_plan'))] }}
            title={t('test_plans')}
        />
    );
};

export default TestPlansPopover;
